//Base Url
export const BASE_URL = {

  // Development
  // BASE_API_URL: "https://company-api.zorem.dev/v1/",

  // Production
  BASE_API_URL: "https://company-api.trackship.co/v1/",
};
